import styled from 'styled-components';

export const FlexContainer = styled.div`
  display: flex;
  justify-content: start;
  width: 100%;
  height: 100%;
`;
